import { Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { OrderContactStore } from './order-contact.store';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { StepperComponent } from '../../shared/Components/stepper/stepper.component';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { OrderContactDataInputComponent } from './order-contact-data-input/order-contact-data-input.component';
import { OrderContactConfirmationComponent } from './order-contact-confirmation/order-contact-confirmation.component';
import { OrderContactSuccessComponent } from './order-contact-success/order-contact-success.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { ErrorComponent } from '../../shared/Components/error/error.component';
import { CommonNavBarComponent } from '../../shared/Components/common-nav-bar/common-nav-bar.component';
import { LoadingSpinnerComponent } from '../../shared/Components/loading-spinner/loading-spinner.component';

@Component({
  selector: 'debtor-panel-order-contact',
  templateUrl: './order-contact.component.html',
  styleUrls: ['./order-contact.component.scss'],
  imports: [TranslateModule, FormsModule, ReactiveFormsModule,
    CommonModule, StepperComponent, CdkStepperModule,
    OrderContactDataInputComponent, OrderContactConfirmationComponent, OrderContactSuccessComponent,
    MatFormFieldModule, MatDatepickerModule, MatSelectModule, MatButtonModule, ErrorComponent, CommonNavBarComponent, LoadingSpinnerComponent],
  providers: [OrderContactStore],
})
export class OrderContactComponent {
  protected readonly store = inject(OrderContactStore);

  protected confirmData(): void {
    this.store.loadDateForConfirmation(this.store.form()?.value);
    this.store.nextStep();
  }

  protected submit(): void {
    this.store.submitOrder();
  }

  protected previousPage(): void {
    this.store.previousStep();
  }

  protected navigateToDashboard(): void {
    this.store.navigateToDashboard();
  }

  protected handleReload(): void {
    this.store.init();
  }
}
